export default "__VITE_ASSET__CZHN9_2K__"